export const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,99}$/;
export const phoneFormatRegex = /^(?=.*?[0-9]).{8,20}$/;
export const numberOnlyRegex = /^[0-9]*$/;
